export default __webpack_public_path__ + "99de9fba5ce79da2efe076d80003c5ec.svg";